import { FileExplorer } from '../components/files/FileExplorer';

export function FilesPage() {
  return (
    <div className="h-full flex flex-col">
      <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 flex-shrink-0">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Files</h1>
          <p className="text-sm text-gray-500 mt-0.5">Manage documents and attachments</p>
        </div>
      </div>
      <div className="flex-1 overflow-hidden">
        <FileExplorer />
      </div>
    </div>
  );
}
